import { render } from "./BuscadorStandalone.vue?vue&type=template&id=31f1cefe&scoped=true"
import script from "./BuscadorStandalone.vue?vue&type=script&lang=js"
export * from "./BuscadorStandalone.vue?vue&type=script&lang=js"

import "./BuscadorStandalone.vue?vue&type=style&index=0&id=31f1cefe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31f1cefe"]])

export default __exports__